var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"direct-links"},_vm._l((_vm.buttons),function(button,index){return _c('a',{key:index,staticClass:"btn btn-sm btn--plain btn--primary",attrs:{"href":button.href,"id":button.id}},[_vm._v(" "+_vm._s(button.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }